import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../Axios/AxiosInstance';
import './ProductList.css';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import { TableTextConstants, TextConstants } from '../../Constants/Constants';
import ReusableTable from '../../Components/Table/ReusableTable';

const ProductList = () => {
  const { date, dealerId, painterId } = useParams();
  const [productData, setProductData] = useState([]);
  
  const [isLoading, setIsLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageDataRef = useRef({});

  useEffect(() => {
    fetchProductData();
  }, [date, dealerId, painterId,currentPage,rowsPerPage]);

  const fetchProductData = async () => {
    const cacheKey = `${currentPage}-${rowsPerPage}`;
    if (pageDataRef.current[cacheKey]) {
      setProductData(pageDataRef.current[cacheKey]);
    } else {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(`/Approval/GetProductDataByPainter?selectedDate=${date}&dealerId=${dealerId}&painterId=${painterId}`, {
          params: {
            PageNumber: currentPage,
            PageSize: rowsPerPage,
          },
        });
  
        const { approvalProductData, paginatedData } = response.data;
  
        if (approvalProductData && Array.isArray(approvalProductData)) {
          const formattedData = approvalProductData.map(item => {
            // Split the scannedDate to get the date part and convert it to DD/MM/YYYY
            const [year, month, day] = item.scannedDate.split('T')[0].split('-');
            const formattedDate = `${day}/${month}/${year}`;
  
            return {
              scannedDate: formattedDate,
              painterName: item.painterName,
              dealerName: item.dealerName,
              handlingCharges: item.handlingCharges,
              totalAmount: item.totalAmount,
              totalFinalAmount: item.totalFinalAmount,
              dealerId: item.dealerId,
              painterId: item.painterId,
              processOrderNumber: item.processOrderNumber,
              qrCode: item.qrCode,
              productName: item.productName
            };
          });
  
          setProductData(formattedData);
          setTotalRecords(paginatedData.totalRecords);
          pageDataRef.current[cacheKey] = formattedData;
        } else {
          console.error('Data format is incorrect or missing:', approvalProductData);
        }
      } catch (error) {
        console.error('Error fetching approval data:', error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  
  const columns = [
    { key: 'scannedDate', label: 'Date' },
    { key: 'dealerName', label: 'Dealer Name' },
    { key: 'painterName', label: 'Painter Name' },
    { key: 'productName', label: 'Product Name' },
    { key: 'qrCode', label: 'Qr Code' },
    { key: 'processOrderNumber', label: 'Process Order Number' },
    { key: 'totalAmount', label: 'Amount', isTextAlignRight: true, isCurrency: true },
    { key: 'handlingCharges', label: 'Handling Fee', isTextAlignRight: true, isCurrency: true },
    { key: 'totalFinalAmount', label: 'Total Amount', isTextAlignRight: true, isCurrency: true },
  ];

  const handleSelectedRowsChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows);
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header title={`${TextConstants.productListTitle}`} />
      <div className="flex flex-col flex-1 mx-2 my-3">
        <div className="flex justify-end">
          <div className="bg-[#1e365e] text-white px-3.5 py-2 rounded-full shadow-md">
            <span className="text-md ">
              Date: {new Date(date).toLocaleDateString('en-GB')}
            </span>
          </div>
        </div>

        <div className="mt-3 p-1">
          <ReusableTable
            data={productData}
            columns={columns}
            rowsPerPage={rowsPerPage}
            loading={isLoading}
            currentPage={currentPage}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onSelectedRowsChange={handleSelectedRowsChange}
          />
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default ProductList;
